<template>
  <div class="banner">
    <el-form>
      <el-form-item label='圖片名稱:'>
        <input maxlength="100" class="el-input__inner" type="text" v-model="banner.imgName">
      </el-form-item>

      <el-form-item label='排序:'>
        <input maxlength="100" class="el-input__inner" type="text"
        v-model="banner.sort"
        @change="banner.sort=banner.sort.replace(/\D+/g, '')" >
        <span>數字越小越靠前</span>
      </el-form-item>

      <el-form-item label="上傳圖片:" class="picupload">
        <el-upload
          action=''
          :http-request='uploadRequest'
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :with-credentials= "true"
          :on-remove="handleRemove"
          :on-error ='$errorImage'
          :file-list="imgUrl"
          :on-exceed="$handleExceed.bind(this,1)"
          :on-change="handleChange"
          :before-upload="beforePicUpload"
          :limit= 1
          accept=".jpg,.jpeg,.png"
          :multiple='false'
          name= 'multipartFile'
          list-type="picture-card">
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">需上傳完整750*340的banner，支持jpg/png格式(2MB以內)</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="bottomBtn">
      <div class="btn" @click="submitBanner()">發佈</div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from '@/components/dialog';

export default {
  props: ['type','id'],
  data () {
    return {
      banner: {
        imgName: '',
        sort: '',
      },
      imgUrl: [],
      dialogVisible: false,
    }
  },
  created(){
    let _this = this;
    if(_this.type === 'edit') {
      _this.initBanner();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    initBanner(){
      let _this = this;
      let param = {
        id: _this.id
      }
      _this.$get(`/request/mall/MallBanner/${this.id}`, {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            _this.banner={
              imgName: res.data.bannerName,
              sort: res.data.bannerSort
            }
            _this.imgUrl.push({name: 'img.jpg', url: res.data.bannerMain});
            document.getElementsByClassName('el-upload')[0].style.display = 'none';
          }
          else{
            _this.$propMessage(res.message,'error');
          };
        });
    },
    // 图片上传之前回调函数
    beforePicUpload (file) {
      let _this = this;
      const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png');
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片只能是jpg或者png格式','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      };
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片大小不能超過2MB','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      const isWidth = new Promise((resolve, reject) => {
        let width = 750
        let height = 340
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width === width && img.height === height;
          valid ? resolve() : reject(new Error())
          if (file.size > 1024*1024*2) {
            _this.$imageConversion.compress(file, {
              quality: 0.3
            }).then(res =>{
              resolve(res);
            })
          } else {
            resolve(file);
          }
        }
        img.src = _URL.createObjectURL(file);
      }).then(() => {
          return file
      }, () => {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片大小需為750*340','error',function(){
          _this.dialogVisible = false;
        });

          return Promise.reject(new Error())
      })
      return isJPG && isLt2M && isWidth;
    },
    uploadRequest(option){
      const file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
        const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.$randomString(4)//  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        const fileWay = 'resource/image/'
        const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {headers:{'Cache-Control':'public'}})
          .then((val) => {
            if (val.res.statusCode === 200) {
              self.imgUrl.push({name: 'img.jpg', url: self.$GLOBAL.picFileUrl + val.name})
              //cdn预热
              self.$cdnFun(self.imgUrl[0].url).then(res=>{
                console.log(res)
              })
              document.getElementsByClassName('el-upload')[0].style.display = 'none';
              return val
            } else {
              console.log('上传失败1')
            }
          }, err => {
            console.log(err,'上传失败')
            reject(err)
          })
        })
      })
    },
    // 移除图片的回调函数
    handleRemove (file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.imgUrl);
      document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';

    },
    // 图片列表发生改变的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    submitBanner(){
      let _this = this
      if(_this.banner.imgName === ''|| _this.$getCaption(_this.banner.imgName)){
        _this.dialogVisible = true;
        _this.$propMessage('圖片名稱不能爲空或者含有非法字符','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }
      if(_this.banner.sort === ''){
        _this.dialogVisible = true;
        _this.$propMessage('排序不能爲空','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }
      if(this.imgUrl.length === 0){
        _this.dialogVisible = true;
        _this.$propMessage('圖片不能爲空','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }
      let param = {
        bannerName: _this.banner.imgName,
        sort: _this.banner.sort,
        bannerImage: _this.imgUrl[0].url
      }
      let editParam = {
        id: _this.id,
        bannerName: _this.banner.imgName,
        sort: _this.banner.sort,
        bannerImage: _this.imgUrl[0].url
      }
      if (_this.type==='add') {
        _this.$post('/request/mall/MallBanner', param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('新增banner圖成功，請稍後', 'success', 
                function(){
                  _this.dialogVisible = false;
                  _this.$router.push('/marketBannerList');
                });
            }
            else {
              _this.$propMessage(res.message, 'error',
                function(){
                  _this.dialogVisible = false;
                });
            };
          });
      } else {
        _this.$put('/request/mall/MallBanner', editParam, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('修改banner圖成功，請稍後', 'success',
              function(){
                _this.dialogVisible = false;
                _this.$router.push('/marketBannerList');
              });
            }
            else {
              _this.$propMessage(res.message, 'error',
                function(){
                  _this.dialogVisible = false;
                });
            };
          });
      }
    }
  },
  components: {
    DiaMess,
  }
};
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/marketBanner.vue